import { applyPlaceholdersToRecord, parseVersion } from '@/core/utils/installation'

import type { BuildSetupCommandMapParams } from '../interfaces'

import { computeGcgNames, toGcgPlaceholders } from './computeGcgNames'

export const buildSetupCommandMap = ({
  selectedTechnology,
  technologySetupCommands,
  libraryData,
  registry,
  packageManager,
}: BuildSetupCommandMapParams): Record<string, string> => {
  if (!selectedTechnology) return {}

  const commands = technologySetupCommands[selectedTechnology] ?? {}
  const version = libraryData?.version ? parseVersion(libraryData.version, selectedTechnology) : 'unknown-version'
  const names = computeGcgNames({ selectedTechnology, libraryData })

  return applyPlaceholdersToRecord(commands, {
    ...toGcgPlaceholders(names),
    registry,
    packageManager,
    library: libraryData?.name ?? 'unknown-library',
    version,
  })
}
